import React, { useState } from 'react';
import './investors.css';
import buttonArrow from '../../assets/icons/button-arrow.svg';
import contactBgImg from '../../assets/home/contact-bg.png';
import { sendContactEmail } from '../../utils/emailjs';

const InvestorPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSent, setIsSent] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await sendContactEmail(formData, 'Investors');
    setIsSent(true);
    setFormData({
      name: '',
      email: '',
      message: '',
    });
  };

  return (
    <section className="kw__investor-page">
      <div className="kw__investor-hero">
        <div className="kw__investor-card">
          <h1 className="kw__investor-title">
            Take a Step Towards
            <br />
            Your Business Success!
          </h1>
          <p className="kw__investor-copy">
            Empowering visionary leaders and entrepreneurs, we are a trusted strategic partner for businesses ready to scale operations and achieve sustainable growth. Through precision-backed execution and data-driven planning, we transform ambitions into measurable outcomes.
          </p>

          <form className="kw__investor-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Message"
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type="submit" className="kw__investor-submit">
              <span className="kw__investor-submit-text">Leave Us a Message</span>
              <span className="kw__investor-submit-icon">
                <img src={buttonArrow} alt="" />
              </span>
            </button>
          </form>

          {isSent && <p className="kw__investor-success">Thank you, we will contact you shortly.</p>}
        </div>
      </div>

      <div className="kw__investor-image-band" aria-hidden="true">
        <img src={contactBgImg} alt="" />
      </div>
    </section>
  );
};

export default InvestorPage;
